import { createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit';

import { ModelDataList } from '@/types/c2/sse.types';
import { NotificationType } from '@/types/data/data.types';

import { userLogout } from '../authent/authent.reducer';
import { notificationAdapter } from './data.adapters';

export type DataState = {
  ongoingNotifications: EntityState<NotificationType, string>;
};

export const DATA_INITIAL_STATE: DataState = {
  ongoingNotifications: notificationAdapter.getInitialState(),
};

const dataReducers = createSlice({
  name: 'data',
  initialState: DATA_INITIAL_STATE,
  reducers: {
    initNotifications(state, action: PayloadAction<NotificationType[]>) {
      state.ongoingNotifications = notificationAdapter.setAll(state.ongoingNotifications, action.payload);
    },
    updateNotification: ({ ongoingNotifications }, action: PayloadAction<NotificationType>) => {
      notificationAdapter.upsertOne(ongoingNotifications, action.payload);
    },
    updateNotifications(state, action: PayloadAction<ModelDataList<NotificationType>>) {
      state.ongoingNotifications = notificationAdapter.upsertMany(state.ongoingNotifications, action.payload.dataList);
    },
    deleteNotification: ({ ongoingNotifications }, action: PayloadAction<NotificationType>) => {
      notificationAdapter.removeOne(ongoingNotifications, action.payload.id);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(userLogout, () => DATA_INITIAL_STATE);
  },
});

export default dataReducers.reducer;

export const { initNotifications, updateNotification, updateNotifications, deleteNotification } = dataReducers.actions;
